import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function AuthorsSection() {
  const {
    t
  } = useLanguage();
  return <section id="autores" className="relative w-full py-8 sm:py-14" data-id="element-20">
      {/* Background accent */}
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-purple-electric/[0.03] rounded-full blur-[120px] pointer-events-none" data-id="element-21" />
      <div className="absolute top-1/3 right-0 w-[300px] h-[300px] bg-gold/[0.03] rounded-full blur-[100px] pointer-events-none" data-id="element-22" />

      <div className="relative max-w-6xl mx-auto px-6" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-6 sm:mb-10" data-id="element-24">
          <p className="font-sans text-sm text-gold tracking-[0.2em] uppercase mb-4" data-id="element-25">
            {t('authors.eyebrow')}
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-26">
            {t('authors.title')}
          </h2>
          <p className="font-sans text-white/40 text-lg max-w-2xl mx-auto" data-id="element-27">
            {t('authors.subtitle')}
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-28">
          {/* Nicolás Pereira */}
          <motion.div variants={cardVariants} className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-6 sm:p-8 overflow-hidden" data-id="element-29">
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-electric/40 to-transparent" data-id="element-30" />

            <div className="flex flex-col items-center text-center" data-id="element-31">
              {/* Avatar */}
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-electric/20 to-purple-electric/5 border border-purple-electric/20 flex items-center justify-center mb-6" data-id="element-32">
                <span className="font-serif text-2xl font-bold text-purple-electric-light" data-id="element-33">
                  NP
                </span>
              </div>

              <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-34">
                {t('authors.nicolas.name')}
              </h3>
              <p className="font-sans text-sm text-purple-electric-light/70 tracking-wide uppercase mb-4" data-id="element-35">
                {t('authors.nicolas.role')}
              </p>
              <p className="font-sans text-white/40 leading-relaxed" data-id="element-36">
                {t('authors.nicolas.bio')}
              </p>
            </div>
          </motion.div>

          {/* Gabriel Beltrán */}
          <motion.div variants={cardVariants} className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-6 sm:p-8 overflow-hidden" data-id="element-37">
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-38" />

            <div className="flex flex-col items-center text-center" data-id="element-39">
              {/* Avatar */}
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-gold/20 to-gold/5 border border-gold/20 flex items-center justify-center mb-6" data-id="element-40">
                <span className="font-serif text-2xl font-bold text-gold-light" data-id="element-41">
                  GB
                </span>
              </div>

              <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-42">
                {t('authors.gabriel.name')}
              </h3>
              <p className="font-sans text-sm text-gold-light/70 tracking-wide uppercase mb-4" data-id="element-43">
                {t('authors.gabriel.role')}
              </p>
              <p className="font-sans text-white/40 leading-relaxed" data-id="element-44">
                {t('authors.gabriel.bio')}
              </p>
            </div>
          </motion.div>
        </motion.div>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-serif text-xl sm:text-2xl text-white/30 text-center mt-5 sm:mt-8 italic" data-id="element-45">
          {t('authors.tagline')}
        </motion.p>
      </div>
    </section>;
}